import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SessionStateService } from '../session/session-state.service';

export const PUBLIC_AUTH_ROUTE_PREFIXES = ['/login', '/forgot/password', '/reset/password', '/first-access/password'];

export function isPublicAuthRoute(url: string): boolean {
  return PUBLIC_AUTH_ROUTE_PREFIXES.some(route => url === route || url.startsWith(`${route}/`));
}

const PUBLIC_ROUTE_PREFIXES = PUBLIC_AUTH_ROUTE_PREFIXES;

@Injectable({
  providedIn: 'root'
})
export class AuthRouteEnforcerService {
  private readonly router = inject(Router);

  private readonly sessionState = inject(SessionStateService);

  public enforceCurrentRoute(): void {
    const url = this.router.url.split('?')[0] ?? '';

    if (this.isPublicRoute(url)) {
      return;
    }

    if (this.sessionState.isRevoked()) {
      void this.router.navigateByUrl(environment.configs.unauthenticatedRoute, { replaceUrl: true });
    }
  }

  private isPublicRoute(url: string): boolean {
    return PUBLIC_ROUTE_PREFIXES.some(route => url === route || url.startsWith(`${route}/`));
  }
}
